import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import Services from "./Services.svelte";

export default {
    component: Services,
    name: "Services",
    description: "Display services or offerings in a structured layout",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/list-details.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F6c64072235154c7a95418f64c734bd00",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/atoms-services--docs`,
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
            required: true,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "CTA Text",
            name: "linkText",
            type: "string",
        },
        {
            friendlyName: "CTA Link",
            name: "linkUrl",
            type: "string",
        },
        {
            friendlyName: "Items",
            name: "items",
            type: "list",
            subFields: [
                {
                    friendlyName: "Name",
                    name: "name",
                    type: "text",
                    required: true,
                },
                {
                    friendlyName: "Description",
                    name: "description",
                    type: "longText",
                    required: true,
                },
            ],
        },
    ],
};
